module.exports = __webpack_public_path__ + "static/media/light_medium_4750.png.ea149c18.webp";